module.exports = __webpack_public_path__ + "static/media/green_circle.2331fb33.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/green_circle.png
// module id = 1127
// module chunks = 0